import styles from "./toolbox-components.module.css";
import { useRef, useEffect, useState } from "react";
import { TwitterPicker } from "react-color";
import { createPortal } from "react-dom";
import { ToolboxComponentDropdown as DropDown } from "./toolbox-component-dropdown";

interface ToolboxComponentColorPickerProps {
  title?: string;
  showSwatch: boolean;
  colors: string[];
  selectedColor: string;
  onHoverColor?: (color: string) => void;
  onSelectColor: (color: string) => void;
  isExpanded: boolean;
  onToggleExpand?: () => void;
}

export const ToolboxComponentColorPicker = (
  props: ToolboxComponentColorPickerProps
) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (props.isExpanded && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setPickerPosition({
        top: rect.bottom + window.scrollY, // Adjust this to fine-tune
        left: rect.left + window.scrollX,
      });
    }
  }, [props.isExpanded]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        props.isExpanded &&
        containerRef.current &&
        overlayRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        !overlayRef.current.contains(event.target as Node)
      ) {
        if (props.onToggleExpand) {
          props.onToggleExpand();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props, props.isExpanded]);

  return (
    <>
      <div ref={containerRef} className={styles.colorPickerContainer}>
        {props.showSwatch && (
          <div
            className={styles.colorPickerSwatch}
            onClick={() => {
              if (props.onToggleExpand) {
                props.onToggleExpand();
              }
            }}
          >
            <div
              className={styles.colorPickerSwatchCircle}
              style={{ backgroundColor: props.selectedColor }}
            />
            <span className={styles.colorPickerSwatchText}>{props.title}</span>
          </div>
        )}
      </div>
      {props.isExpanded &&
        createPortal(
          <div
            id="dropdown-portal"
            ref={overlayRef}
            className={`${styles.colorPickerOverlay} ${
              props.isExpanded ? styles.open : ""
            }`}
            style={{
              position: "absolute", // Ensure it positions absolutely
              top: pickerPosition.top,
              left: pickerPosition.left,
              zIndex: 1000, // Make sure it's above other elements
            }}
          >
            <TwitterPicker
              colors={props.colors}
              color={props.selectedColor}
              onChangeComplete={(updatedColor) => {
                props.onSelectColor(updatedColor.hex);
              }}
              className={styles.colorPicker}
              onSwatchHover={(color, event) => {
                // props.onHoverColor(color.hex); // Uncomment if needed
              }}
            />
          </div>,
          document.body
        )}
    </>
  );
};
